const boxShadows = {
    xs: '0px 4px 8px 0px',
    sm: '0px 4px 12px 0px',
    md: '0px 4px 16px 0px',
    lg: '0px 8px 24px 0px',
    xl: '0px 8px 32px 0px',
    xxl: '0px 8px 44px 0px',
} as const;

export default { boxShadows };
